module.exports = __webpack_public_path__ + "img/OpenFBA-Logo-Dark.6a7c5864.svg";